/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Kpi_NegativeInputs */



/**
* | output |
* | --- |
* | "Negative" |
*
* @param {Feedback_Kpi_NegativeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const feedback_kpi_negative = /** @type {((inputs?: Feedback_Kpi_NegativeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Kpi_NegativeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Negativ")
	return /** @type {LocalizedString} */ ("Negative")
});